"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementType = void 0;
var ManagementType;
(function (ManagementType) {
    ManagementType[ManagementType["Install"] = 0] = "Install";
    ManagementType[ManagementType["InstallDev"] = 1] = "InstallDev";
    ManagementType[ManagementType["Update"] = 2] = "Update";
})(ManagementType = exports.ManagementType || (exports.ManagementType = {}));
